export default __webpack_public_path__ + "static/media/humble_black.e89e4129.svg";